export default "__VITE_ASSET__DHeY1bBe__"